import { useEffect, useState } from 'react'
import { updateCrmContact, listWhatsappInstances, atCreateConversation } from '../../db/api.js'
import { useApp } from '../../context/AppContext.jsx'

const demo = import.meta.env.DEV && import.meta.env.MODE === 'demo'
export default function ChatPhoneSetup({ leadId, dealId, initialPhone, onSaved }) {
  const { selectedClient } = useApp()
  const [phone, setPhone] = useState(initialPhone || '')
  const [instances, setInstances] = useState([])
  const [instance, setInstance] = useState('')
  const [loading, setLoading] = useState(!demo)
  const [saving, setSaving] = useState(false)
  const [notice, setNotice] = useState('')
  useEffect(() => {
    if (demo) return
    let alive = true
    listWhatsappInstances({ refresh: true }).then((rows) => {
      if (!alive) return
      const available = rows.filter((row) => row.status === 'open' && (!selectedClient?.id || row.client_id === selectedClient.id))
      setInstances(available); setInstance(available[0]?.instance_name || '')
    }).catch(() => { if (alive) setNotice('Não foi possível consultar as conexões do WhatsApp.') })
      .finally(() => { if (alive) setLoading(false) })
    return () => { alive = false }
  }, [selectedClient?.id])
  const save = async (event) => {
    event.preventDefault()
    if (saving) return
    const digits = phone.replace(/\D/g, '')
    const number = !phone.trim().startsWith('+') && [10, 11].includes(digits.length) ? `55${digits}` : digits
    if (!/^[1-9]\d{9,14}$/.test(number)) { setNotice('Informe um número válido com código do país e DDD.'); return }
    setSaving(true); setNotice('')
    try {
      if (demo) {
        const { saveDemoWhatsapp } = await import('../../demo/data.js')
        const conversation = saveDemoWhatsapp(dealId, number)
        onSaved(number, conversation)
      } else {
        await updateCrmContact(leadId, { telefone: `+${number}` })
        onSaved(number, null)
        if (!instance) { setNotice('Número salvo. Conecte um WhatsApp em Perfil › Integrações para enviar mensagens.'); return }
        const conversation = await atCreateConversation({ contact_id: leadId, deal_id: dealId, channel: 'whatsapp', wa_provider: 'evolution', wa_instance_name: instance, wa_remote_jid: `${number}@s.whatsapp.net` })
        onSaved(number, conversation)
      }
    } catch (e) { setNotice(e.message || 'Não foi possível concluir. Tente novamente.') }
    finally { setSaving(false) }
  }
  return <form className="pl-chat-phone-setup" onSubmit={save}>
    <strong>{initialPhone ? 'Iniciar conversa' : 'Adicionar WhatsApp'}</strong>
    <label>Número do contato<input type="tel" autoComplete="tel" required placeholder="+55 (11) 99999-9999" value={phone} disabled={saving} onChange={(event) => setPhone(event.target.value)} /></label>
    {!demo && instances.length > 0 && <label>Enviar por<select value={instance} disabled={saving} onChange={(event) => setInstance(event.target.value)}>{instances.map((row) => <option key={row.instance_name} value={row.instance_name}>{row.phone || row.instance_name}</option>)}</select></label>}
    <button type="submit" disabled={saving || loading || !leadId}>{saving ? 'Salvando…' : loading ? 'Carregando conexões…' : 'Salvar e abrir conversa'}</button>
    {!leadId && <p>Vincule um contato principal ao negócio para salvar o número.</p>}
    {notice && <p role="status">{notice}</p>}
    {demo && <small>Salvo apenas na demonstração local.</small>}
  </form>
}
